export default function gaugeType({ type }) {
  let degreeOfDial = ''
  let typeTxt = ''
  let color = ''
  switch (type) {
    case 'EXTREMELY_BEARISH':
      degreeOfDial = '0deg'
      typeTxt = 'Bearish'
      color = 'text-brand-red-cinnabar'
      break
    case 'sell':
      degreeOfDial = '25deg'
      break
    case 'BEARISH':
      degreeOfDial = '70deg'
      typeTxt = 'Bearish'
      color = 'text-brand-red-cinnabar'
      break
    case 'neutral':
    case 'NEUTRAL':
      degreeOfDial = '90deg'
      typeTxt = 'Neutral'
      color = 'text-brand-grey-base'
      break
    case 'buy':
      degreeOfDial = '150deg'
      break
    case 'BULLISH':
      degreeOfDial = '115deg'
      typeTxt = 'Bullish'
      color = 'text-brand-green-dark'
      break
    case 'EXTREMELY_BULLISH':
      degreeOfDial = '180deg'
      typeTxt = 'Bullish'
      color = 'text-brand-green-dark'
      break
    default:
      break
  }
  return {
    degreeOfDial,
    typeTxt,
    color,
  }
}
